module.exports = __webpack_public_path__ + "static/media/silo_image.e35947be.jpg";